/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, memo } from "react";
import { Card, Image, Button } from "react-bootstrap";
import Emp_data_pic from "../../assets/images/Emp_data_pic.png";
import { AiOutlineSearch } from "react-icons/ai";
import { AutoComplete, DatePicker, Select } from "antd";
import "./report.css";
import moment from "moment";

import {
  Table,
  TableHeadCell,
  TableBody,
  TableBodyCell,
  TableHead,
} from "../setting/PatientPortalSettings/StyledComponents";
import { Tablerow } from "../patient/StyledComponent";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { Encrypt_Value } from "../schedule/EncryptDecrypt";
import axiosInstance from "../../axios/axios";
import Loader from "../popups/Loading";
import { parsePhoneForDisplay } from "../patient/ParsePhoneForDisplay";
import CustomSuffixIcon from "../popups/CustomSuffixIcon";

// const { RangePicker } = DatePicker;
const { Option } = Select;

function DenialAnalysisReportTable() {
  // ----------------------------
  // basic decrypted/config values
  // ----------------------------
  const dateFormat = localStorage.getItem("dateFormat") || "YYYY/MM/DD";
  const dtFormat = dateFormat;
  const storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  const authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  const main_pro = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  const owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  const user_ID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  // ----------------------------
  // UI / input state
  // ----------------------------
  const [spinner, setspinner] = useState(true);

  // patient search (same logic as Eligibility)
  const [search, setSearch] = useState("");
  const [patname, setpat] = useState(""); // selected patient id
  const [patsrchvalue, setpatsrchvalue] = useState("");
  const [forpatsrchload, setforpatsrchload] = useState(false);
  const [source, setSource] = useState([]); // patient suggestions
  const [fornoresults, setfornoresults] = useState("1");

  // facility dropdown
  const [office, setoffice] = useState("");
  const [alloffice, setalloffice] = useState([]);

  // payer dropdown
  const [search2, setSearch2] = useState("");
  const [filterpayer, setfilterpayer] = useState([]);
  const [fornoresults1, setnoresult1] = useState("1");
  const [payId, setPayId] = useState("");

  // denial search (new)
  const [denialSearch, setDenialSearch] = useState("");
  const [denialSearchValue, setDenialSearchValue] = useState("");
  const [forDenialLoad, setForDenialLoad] = useState(false);
  const [denialOptions, setDenialOptions] = useState([]); // autocomplete options
  const [forNoResultsDenial, setForNoResultsDenial] = useState("1");
  const [selectedDenialRow, setSelectedDenialRow] = useState(null); // store selected row (batch/encounter)

  // date range
  const [fromdt, setfrom] = useState(
    moment().add(-7, "days").format("YYYY-MM-DD"),
  );
  const [todt, settodt] = useState(moment().format("YYYY-MM-DD"));

  // table data / pagination
  const [mainrows, setmainrows] = useState([]); // full dataset (dummy or API)
  const [tableData, setTableData] = useState([]); // visible slice
  const [showLoading, setShowLoading] = useState("none");
  const [offVal, setoffval] = useState(40);
  const [load_flag, setload_flag] = useState(0);

  // small UI control
  const [showTitle, setShowTitle] = useState(true);
  const [countryCodes, setCountryCodes] = useState([]);

  // ----------------------------

  // ----------------------------
  // helpers
  // ----------------------------
  const timeout = (ms) => new Promise((res) => setTimeout(res, ms));

  // ----------------------------
  // facility fetch (same as ProductProceduresTable)
  // ----------------------------
  const getFacilityDatas = async () => {
    try {
      const group_id = Decrypt_Value(localStorage.getItem("group_id"), "vozo");
      let input =
        "authorized=" +
        authorized +
        "&main_pro=" +
        main_pro +
        "&group_id=" +
        group_id;
      let dta = Encrypt_Value(input, "vozo");
      const res = await axiosInstance.get(
        "/vozonew/facility/all?search=" + dta,
      );
      const decoded = Decrypt_Value(res.data, "vozo");
      setalloffice(decoded || []);
    } catch (err) {
      setalloffice([]);
    }
  };

  // ----------------------------
  // patient dropdown (eligibility style)
  // ----------------------------
  const patdropdown = async () => {
    try {
      let article =
        "limit=10&fname=" +
        search +
        "&authorized=" +
        authorized +
        "&main_pro=" +
        main_pro +
        "&userID=" +
        user_ID +
        "&pat_share=" +
        storedNames.pat_share +
        "&owner_id=" +
        owner_id;
      let data = Encrypt_Value(article, "vozo");
      const res = await axiosInstance.get("/vozo/patientsearch?search=" + data);
      const res3 = Decrypt_Value(res.data, "vozo");
      if (res3.length > 0) {
        setSource(res3);
        setfornoresults(res3);
      } else {
        setSource([]);
        setfornoresults("");
      }
    } catch (err) {
      setSource([]);
      setfornoresults("");
    }
  };

  // ----------------------------
  // payer dropdown (eligibility style)
  // ----------------------------
  const payerdropdown = async () => {
    try {
      let article1 = "limit=10&payer=" + search2;
      let data = Encrypt_Value(article1, "vozo");
      const res = await axiosInstance.get(
        "/vozonew/insurance_company/names?search=" + data,
      );
      const res3 = Decrypt_Value(res.data, "vozo");
      setfilterpayer(res3);
      setnoresult1(res3);
    } catch (err) {
      setfilterpayer([]);
      setnoresult1("");
    }
  };

  // ----------------------------
  // denial dropdown (new) - calls backend /vozo/denialsearch
  // ----------------------------
  const denialdropdown = async () => {
    try {
      let article = "limit=10&query=" + (denialSearchValue || "");
      let data = Encrypt_Value(article, "vozo");
      const res = await axiosInstance.get("/vozo/denialsearch?search=" + data);
      const decoded = Decrypt_Value(res.data, "vozo") || [];

      if (decoded.length > 0) {
        // build options parsing reason JSON
        const options = decoded.map((row) => {
          let reasonArr = [];
          try {
            reasonArr = JSON.parse(row.reason);
          } catch (e) {
            reasonArr = [];
          }

          const r = reasonArr[0] || {};
          const code = r.code || "";
          const description = r.description || "";

          return {
            label: (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ fontWeight: 600 }}>{code}</div>
                <div style={{ fontSize: 12, color: "#555" }}>{description}</div>
              </div>
            ),
            value: code + " - " + description,
            rowData: row,
          };
        });

        setDenialOptions(options);
        setForNoResultsDenial(options);
      } else {
        setDenialOptions([]);
        setForNoResultsDenial("");
      }
    } catch (err) {
      setDenialOptions([]);
      setForNoResultsDenial("");
    }
  };

  // ----------------------------
  // first load: show dummy and fetch facility/country codes
  // ----------------------------
  useEffect(() => {
    const firstload = async () => {
      const article = {
        pname: patname || "",
        denialReason: denialSearch,
        office: "",
        claim: "5",
        payer: payId || "",
        start: fromdt,
        end: todt,
        limit: 40,
        offset: 0,
        authorized: authorized,
        main_pro: main_pro,
        owner_id: owner_id,
        userID: user_ID,
        pat_share: storedNames?.pat_share || "",
      };
      getFacilityDatas();
      try {
        const d = Encrypt_Value(article, "vozo");
        // Replace the endpoint below with real backend path when available
        const res = await axiosInstance.put("/vozo/denialAnalysisReport", d);
        const decoded = Decrypt_Value(res.data, "vozo");

        if (decoded[0] && decoded[0].length > 0) {
          const parsed = decoded[0]?.map((r) => {
            let parsedReason = "";
            try {
              const arr = JSON.parse(r.reason || "[]");
              if (Array.isArray(arr) && arr.length > 0) {
                const parts = [];
                if (arr[0].code) parts.push(arr[0].code);
                if (arr[0].description) parts.push(arr[0].description);
                parsedReason = parts.join(" - ");
              } else {
                parsedReason = r.reason || "";
              }
            } catch (e) {
              parsedReason = r.reason || "";
            }
            return {
              ...r,
              patient:
                r.patient_name ||
                r.patient ||
                r.name ||
                r.pname ||
                r.full_name ||
                r.pat_name ||
                (r.pfnm ? r.pfnm + " " + r.plnm : ""),
              patient_id:
                r.patient_id || r.patientId || r.pat_id || r.pid || r.id,
              provider:
                r.provider_name ||
                r.provider ||
                r.dr_name ||
                r.doctor ||
                (r.fname
                  ? r.fname + (r.mname ? " " + r.mname : "") + " " + r.lname
                  : ""),
              facility: r.facility_name || r.office || r.facility || r.center,
              dos:
                r.dos ||
                r.date_of_service ||
                r.DOS ||
                r.appointment_date ||
                r.date ||
                r.appointment,
              claimId: r.claim_id || r.claimId || r.encounter || r.id,
              postingDate:
                r.posting_date ||
                r.postingDate ||
                r.posted_date ||
                r.postdate ||
                r.date ||
                r.posted_at,
              procedureCode:
                r.procedure_code || r.procedureCode || r.billing_code || r.code,
              billedAmount:
                r.billed_amount || r.billedAmount || r.amount || r.total_charge,
              denialDate:
                r.denial_date ||
                r.denialDate ||
                r.denied_date ||
                r.date ||
                r.denied_at,
              denialReason: parsedReason,
            };
          });
          setmainrows(parsed);
          setTableData(parsed.slice(0, 15));
          setShowLoading(parsed.length > 15 ? "block" : "none");
        } else {
          setmainrows([]);
          setTableData([]);
          setShowLoading("none");
        }
        setspinner(false);
      } catch (e) {}
      setspinner(false);
    };
    firstload();
  }, []);

  // ----------------------------
  // patient search handlers
  // ----------------------------
  const PatientSearch = (data) => {
    setfornoresults("1");
    setSource([]);
    setforpatsrchload(true);
    setpatsrchvalue(data);
    setSearch(data);
    if (data === "") setpat("");
  };

  const PatientSelect = (data) => {
    let a = data.split("-");
    setSearch(a[1]);
    setpat(a[0]);
  };

  useEffect(() => {
    let isCancelled = false;
    const handle = async () => {
      await timeout(700);
      if (!isCancelled && forpatsrchload) {
        patdropdown();
      }
    };
    handle();
    return () => {
      isCancelled = true;
    };
  }, [patsrchvalue]);

  // ----------------------------
  // payer search handlers
  // ----------------------------
  const payerchange = (data) => {
    setSearch2(data);
    setfilterpayer([]);
    setnoresult1("1");
    if (data === "") setPayId("");
  };

  useEffect(() => {
    let isCancelled = false;
    const handle = async () => {
      await timeout(700);
      if (!isCancelled && search2 !== "") payerdropdown();
    };
    handle();
    return () => {
      isCancelled = true;
    };
  }, [search2]);

  // ----------------------------
  // denial search handlers (new)
  // ----------------------------
  const DenialSearch = (data) => {
    setForNoResultsDenial("1");
    setDenialOptions([]);
    setForDenialLoad(true);
    setDenialSearchValue(data);
    setDenialSearch(data);
  };

  const DenialSelect = (val, option) => {
    // option contains rowData
    setDenialSearch(val);
    setSelectedDenialRow(option?.rowData || null);
  };

  useEffect(() => {
    let isCancelled = false;
    const handle = async () => {
      await timeout(700);
      if (!isCancelled && forDenialLoad) {
        denialdropdown();
      }
    };
    handle();
    return () => {
      isCancelled = true;
    };
  }, [denialSearchValue]);

  // ----------------------------
  // date handler
  // ----------------------------
  const mydate = (e) => {
    if (e != null) {
      if (e[0] && e[1]) {
        setfrom(moment(e[0], dateFormat).format("YYYY/MM/DD"));
        settodt(moment(e[1], dateFormat).format("YYYY/MM/DD"));
      }
    } else {
      setfrom("");
      settodt("");
    }
  };

  // ----------------------------
  // load more (dummy / paging)
  // ----------------------------
  const loadMore = () => {
    const rowscount = tableData.length;
    if (mainrows.length > rowscount) {
      const next = mainrows.slice(rowscount, rowscount + 10);
      setTableData((prev) => [...prev, ...next]);
    } else {
      setShowLoading("none");
    }
  };

  // ----------------------------
  // Update / filter (calls backend endpoint placeholder)
  // ----------------------------
  const onSubmit = async () => {
    setspinner(true);
    // build payload similar to other reports
    // const article = {
    //   patientid: patname || "",
    //   userid: "", // provider filter not required for now
    //   payerid: payId || "",
    //   facility: office || "",
    //   startdate: fromdt,
    //   enddate: todt,
    //   limit: 40,
    //   offset: 0,
    //   authorized: authorized,
    //   main_pro: main_pro,
    //   owner_id: owner_id,
    //   userID: user_ID,
    //   pat_share: storedNames.pat_share,
    //   // send denial selector info: prefer selected row batch_id, then encounter, else text
    //   denialquery:
    //     (selectedDenialRow &&
    //       (selectedDenialRow.batch_id || selectedDenialRow.encounter_id)) ||
    //     denialSearch ||
    //     "",
    // };
    const article = {
      pname: patname || "",
      office: "",
      denialReason: denialSearch,
      claim: "5",
      payer: payId || "",
      start: fromdt,
      end: todt,
      limit: 40,
      offset: 0,
      authorized: authorized,
      main_pro: main_pro,
      owner_id: owner_id,
      userID: user_ID,
      pat_share: storedNames?.pat_share || "",
    };

    try {
      const d = Encrypt_Value(article, "vozo");
      // placeholder endpoint — replace with actual when backend ready
      const res = await axiosInstance.put("/vozo/denialAnalysisReport", d);
      const decoded = Decrypt_Value(res.data, "vozo");

      if (decoded[0] && decoded[0].length > 0) {
        // ensure each returned row has patient_id and same fields
        // also attempt to parse any reason JSON into readable fields if present
        const parsed = decoded[0]?.map((r) => {
          let parsedReason = "";
          try {
            const arr = JSON.parse(r.reason || "[]");
            if (Array.isArray(arr) && arr.length > 0) {
              const parts = [];
              if (arr[0].code) parts.push(arr[0].code);
              if (arr[0].description) parts.push(arr[0].description);
              parsedReason = parts.join(" - ");
            } else {
              parsedReason = r.reason || "";
            }
          } catch (e) {
            parsedReason = r.reason || "";
          }
          return {
            ...r,
            patient:
              r.patient_name ||
              r.patient ||
              r.name ||
              r.pname ||
              r.full_name ||
              r.pat_name ||
              (r.pfnm ? r.pfnm + " " + r.plnm : ""),
            patient_id:
              r.patient_id || r.patientId || r.pat_id || r.pid || r.id,
            provider:
              r.provider_name ||
              r.provider ||
              r.dr_name ||
              r.doctor ||
              (r.fname
                ? r.fname + (r.mname ? " " + r.mname : "") + " " + r.lname
                : ""),
            facility: r.facility_name || r.office || r.facility || r.center,
            dos:
              r.dos ||
              r.date_of_service ||
              r.DOS ||
              r.appointment_date ||
              r.date ||
              r.appointment,
            claimId: r.claim_id || r.claimId || r.encounter || r.id,
            postingDate:
              r.posting_date ||
              r.postingDate ||
              r.posted_date ||
              r.postdate ||
              r.date ||
              r.posted_at,
            procedureCode:
              r.procedure_code || r.procedureCode || r.billing_code || r.code,
            billedAmount:
              r.billed_amount || r.billedAmount || r.amount || r.total_charge,
            denialDate:
              r.denial_date ||
              r.denialDate ||
              r.denied_date ||
              r.date ||
              r.denied_at,
            denialReason: parsedReason,
          };
        });

        setmainrows(parsed);
        setTableData(parsed.slice(0, 15));
        setShowLoading(parsed.length > 15 ? "block" : "none");
      } else {
        // no rows -> show empty UI like EligibilityReport
        setmainrows([]);
        setTableData([]);
        setShowLoading("none");
      }
    } catch (err) {
      // backend not ready yet — keep empty results (safe)
      setmainrows([]);
      setTableData([]);
      setShowLoading("none");
    } finally {
      setspinner(false);
    }
  };

  // ----------------------------
  // render
  // ----------------------------
  return (
    <>
      {spinner ? (
        <Loader />
      ) : (
        <div>
          <div className="tab_title_main1">
            <div className="tab_title_name">Denial Analysis Report</div>
          </div>

          {/* Filters */}
          <div className="daysheet-snd-layer rep-flex-align-center backgr-chng claim-filter-wrap">
            <div>
              <div className="col-12 p-l-r-13 d-flex claimreportWrapBtom">
                {/* Patient Search */}
                <div className="for_autoComplete_bi SearchUI m-t-6">
                  <AiOutlineSearch />
                  <AutoComplete
                    virtual={false}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    placeholder=" Patient "
                    className="remainderWidthSheet"
                    onSelect={(data) => PatientSelect(data)}
                    onChange={(data) => PatientSearch(data)}
                    dropdownClassName={search !== "" ? "" : "for_no_loading"}
                    dropdownRender={(menu) => (
                      <div
                        onMouseEnter={() => setShowTitle(false)}
                        onMouseLeave={() => setShowTitle(true)}
                      >
                        {menu}
                      </div>
                    )}
                    notFoundContent={
                      fornoresults.length !== 0
                        ? "loading.."
                        : "No Result Found"
                    }
                    onClick={() => {
                      if (search) patdropdown();
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") patdropdown();
                    }}
                    options={source.map((x) => {
                      const titleText = x.title || x.name || "";
                      const titleLength = titleText.length || 0;
                      return {
                        label: (
                          <div>
                            <div className="toplabel" title={titleText}>
                              {titleLength < 15 ? (
                                <>
                                  {x.title || x.name} -{" "}
                                  {x.dob ? moment(x.dob).format(dtFormat) : ""}
                                </>
                              ) : (
                                <>
                                  <div>{x.title || x.name} -</div>
                                  <div>
                                    {x.dob
                                      ? moment(x.dob).format(dtFormat)
                                      : ""}
                                  </div>
                                </>
                              )}
                            </div>
                            <div>
                              {(() => {
                                const phone = (x.phone_cell || "").replace(
                                  /[^0-9+_ ]/g,
                                  "",
                                );
                                const { countryCode, phoneNumber } =
                                  parsePhoneForDisplay(phone, countryCodes);
                                return `${countryCode} ${phoneNumber}`.trim();
                              })()}
                            </div>
                          </div>
                        ),
                        value: (x.pid || x.id) + "-" + (x.title || x.name),
                      };
                    })}
                    value={search}
                  />
                </div>

                {/* Payer - Select that fetches on open */}
                <div className="rep-day-sht-btn m-t-14 demoPaymentControl">
                  <Select
                    showSearch
                    allowClear
                    virtual={false}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    placeholder="Payer"
                    className="remainderWidthSheet"
                    suffixIcon={<CustomSuffixIcon />}
                    value={search2 || undefined}
                    onDropdownVisibleChange={(open) => {
                      if (open) payerdropdown();
                    }}
                    onChange={(value, option) => {
                      if (!value) {
                        setPayId("");
                        setSearch2("");
                        return;
                      }
                      setPayId(option?.id || value);
                      setSearch2(option?.label || option?.children || "");
                    }}
                    onSearch={(val) => {
                      setSearch2(val);
                      payerchange(val);
                    }}
                    filterOption={false}
                    notFoundContent={
                      filterpayer.length === 0 ? "No Result Found" : null
                    }
                    options={filterpayer.map((x) => ({
                      label: x.name || x.title,
                      value: x.id,
                      id: x.id,
                    }))}
                  />
                </div>

                {/* Denial Search */}
                <div className="for_autoComplete_bi SearchUI m-t-6">
                  <AiOutlineSearch />
                  <AutoComplete
                    virtual={false}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    placeholder="Denial Reason"
                    className="remainderWidthSheet"
                    onSelect={(val, option) => DenialSelect(val, option)}
                    onChange={(data) => DenialSearch(data)}
                    dropdownClassName={
                      denialSearch !== "" ? "" : "for_no_loading"
                    }
                    notFoundContent={
                      forNoResultsDenial.length !== 0
                        ? "loading.."
                        : "No Result Found"
                    }
                    onClick={() => {
                      if (denialSearch) denialdropdown();
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") denialdropdown();
                    }}
                    options={denialOptions}
                    value={denialSearch}
                  />
                </div>

                {/* Date Range */}
                <div
                  id="rpt_pay-inp_dt"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginLeft: "25px",
                    marginTop: "12px",
                    flexShrink: 0,
                  }}
                >
                  <span
                    style={{
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    From
                  </span>

                  <DatePicker
                    className="light-grey-date"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    value={fromdt ? moment(fromdt, "YYYY/MM/DD") : null}
                    format={dateFormat}
                    inputReadOnly
                    allowClear={false}
                    style={{ width: 140, minWidth: 140 }}
                    onChange={(date) => {
                      if (date) {
                        setfrom(moment(date).format("YYYY/MM/DD"));
                      }
                    }}
                  />

                  <span
                    style={{
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    To
                  </span>

                  <DatePicker
                    className="light-grey-date"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    value={todt ? moment(todt, "YYYY/MM/DD") : null}
                    format={dateFormat}
                    inputReadOnly
                    allowClear={false}
                    style={{ width: 140, minWidth: 140 }}
                    onChange={(date) => {
                      if (date) {
                        settodt(moment(date).format("YYYY/MM/DD"));
                      }
                    }}
                  />

                  {/* Update */}
                  <Button
                    variant="primary"
                    className="btn-fnt-wgt button_Click_event_alt"
                    onClick={() => onSubmit()}
                    style={{ marginLeft: "8px" }}
                  >
                    Update
                  </Button>
                </div>
              </div>

              <div className="text-left reportEmptyDiv"></div>
            </div>
          </div>

          {/* Table */}
          <div className="appoint_report_card prior_rep_card_table">
            <Card>
              <Card.Header>
                <div className="modif">
                  <div className="modif_left pat_flag_tit_alt1">
                    Denial List
                  </div>
                </div>
              </Card.Header>

              <div className="bill_summary_table">
                <Table className="appt_rep_table_responsive">
                  <TableHead
                    className="Tab_content_Table_Header appt-head"
                    display="table-header-group"
                    height="40px"
                  >
                    <Tablerow
                      className="schedule-head-row tr-no"
                      fontWeight="400"
                    >
                      <TableHeadCell align="left">Patient</TableHeadCell>
                      <TableHeadCell align="left">Provider</TableHeadCell>
                      <TableHeadCell align="left">Facility</TableHeadCell>
                      <TableHeadCell align="left">DOS</TableHeadCell>
                      <TableHeadCell align="left" style={{ width: "80px" }}>
                        Claim ID
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span>Posting</span>
                          <span>Date</span>
                        </div>
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span>Procedure</span>
                          <span>Code</span>
                        </div>
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span>Insurance</span>
                          <span>Payer</span>
                        </div>
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span>Billed</span>
                          <span>Amount</span>
                        </div>
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span>Denial</span>
                          <span>Date</span>
                        </div>
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100px",
                          }}
                        >
                          <span>Denial</span>
                          <span>Reason</span>
                        </div>
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <span>Denial</span>
                          <span>Amount</span>
                        </div>
                      </TableHeadCell>
                    </Tablerow>
                  </TableHead>

                  <TableBody className="tble-over appt_tab_alt1">
                    {tableData.length > 0 ? (
                      // render rows, but hide patient name when same patient_id repeats
                      tableData.map((row, idx) => {
                        return (
                          <Tablerow
                            key={idx}
                            className="table-data-row schedule-body-row"
                            borderBottom="1px solid #cbd5e0"
                            padding="6px 0 6px 18px"
                            color="#636d73"
                            height="56px"
                          >
                            <TableBodyCell lineHeight="20.02px">
                              {row.patient}
                            </TableBodyCell>
                            <TableBodyCell align="left" lineHeight="20.02px">
                              {row.provider}
                            </TableBodyCell>
                            <TableBodyCell align="left" lineHeight="20.02px">
                              {row.facility}
                            </TableBodyCell>
                            <TableBodyCell align="left" lineHeight="20.02px">
                              {row.dos}
                            </TableBodyCell>
                            <TableBodyCell align="left" lineHeight="20.02px">
                              {row.claimId}
                            </TableBodyCell>
                            <TableBodyCell align="left" lineHeight="20.02px">
                              {row.postingDate}
                            </TableBodyCell>
                            <TableBodyCell align="left" lineHeight="20.02px">
                              {row.procedureCode}
                            </TableBodyCell>
                            <TableBodyCell align="left" lineHeight="20.02px">
                              {row.payer}
                            </TableBodyCell>
                            <TableBodyCell align="left" lineHeight="20.02px">
                              ${row.billedAmount}
                            </TableBodyCell>
                            <TableBodyCell align="left" lineHeight="20.02px">
                              {row.denialDate}
                            </TableBodyCell>
                            <TableBodyCell align="left" lineHeight="20.02px">
                              {row.denialReason || ""}
                            </TableBodyCell>
                          </Tablerow>
                        );
                      })
                    ) : (
                      <Tablerow className="bot_border">
                        <TableBodyCell
                          className="appCellCenter patpor_main_div"
                          colSpan={12}
                        >
                          <div className="img_top">
                            <Image
                              height="133px"
                              width="133px"
                              src={Emp_data_pic}
                            ></Image>
                          </div>
                        </TableBodyCell>
                      </Tablerow>
                    )}
                  </TableBody>
                </Table>
              </div>
            </Card>

            {/* Load more */}
            {tableData.length !== 0 && showLoading === "block" && (
              <div
                className="loading-more pat_flg_loadmore_btn_alt"
                style={{ display: showLoading }}
              >
                <Button
                  id="load-data"
                  style={{ paddingTop: 16 }}
                  variant="primary"
                  className="loading-more-div"
                  onClick={loadMore}
                >
                  Load more...
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default memo(DenialAnalysisReportTable);
